import React from 'react';

const LeadershipLegacySection = () => {
  const notableLeaders = [
    {
      name: "Leo P.S. Senthuran",
      year: "2004-2005",
      achievement: "Transformed inactive club to district champion",
      impact: "First Runner's Up, established foundation for excellence"
    },
    {
      name: "Leo Dinesh",
      year: "2006-2007",
      achievement: "First Most Outstanding Club award",
      impact: "Lions Clubs International Excellence Award"
    },
    {
      name: "Leo Prasath",
      year: "2007-2008",
      achievement: "Second consecutive Excellence Award",
      impact: "Set high standards with 'For the People' theme"
    },
    {
      name: "Leo Krishnaratha",
      year: "2013-2014",
      achievement: "Leo of the World recipient",
      impact: "Made entire Sri Lankan Leo community proud"
    },
    {
      name: "Leo Vaishnavi",
      year: "2013-2014",
      achievement: "Dynamic female leadership",
      impact: "Third consecutive Best Leo Club award"
    },
    {
      name: "Leo Nithushan",
      year: "2021-2022",
      achievement: "International twinning projects",
      impact: "16 District awards, benchmark year"
    }
  ];

  const leadershipPrinciples = [
    {
      icon: "🎯",
      title: "Vision-Driven Leadership",
      description: "Every president brings a unique theme and vision, driving the club toward specific goals and achievements."
    },
    {
      icon: "🤝",
      title: "Collaborative Excellence",
      description: "Success through teamwork, with dedicated board members and enthusiastic club members working together."
    },
    {
      icon: "🌟",
      title: "Innovation & Adaptation",
      description: "Continuously evolving our approach to service, embracing new technologies and methodologies."
    },
    {
      icon: "🏆",
      title: "Quality Over Quantity",
      description: "Focus on meaningful, impactful projects rather than just numbers, ensuring lasting community benefit."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Leadership <span className="text-primary">Legacy</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Three decades of exceptional leadership, where each president has contributed to building 
            a legacy of service excellence and leadership development.
          </p>
        </div>

        {/* Leadership Principles */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Our Leadership Philosophy</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {leadershipPrinciples.map((principle, index) => (
              <div key={index} className="text-center p-6 rounded-2xl bg-gray-50 hover:bg-gradient-to-br hover:from-primary/5 hover:to-secondary/5 transition-all duration-300">
                <div className="text-4xl mb-4">{principle.icon}</div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{principle.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{principle.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Notable Leaders Timeline */}
        {/* <div>
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Transformational Leaders</h3>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-primary to-secondary rounded-full"></div>
            
            <div className="space-y-12">
              {notableLeaders.map((leader, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                    <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100">
                      <div className="text-sm text-primary font-semibold mb-2">{leader.year}</div>
                      <h4 className="text-xl font-bold text-gray-900 mb-2">{leader.name}</h4>
                      <p className="text-secondary font-semibold mb-3">{leader.achievement}</p>
                      <p className="text-gray-600 text-sm">{leader.impact}</p>
                    </div>
                  </div>
                  
                  <div className="relative z-10 w-4 h-4 bg-white border-4 border-primary rounded-full"></div>
                  
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Current Vision & Mission */}
        <div className="mt-20 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-3xl p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Our Vision & Mission 2025/2026</h3>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto">
              Building on our legacy of excellence, we continue to evolve and adapt our approach to leadership development and community service.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 mb-12">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-2xl">👁️</span>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2">Vision 2025/2026</h4>
              </div>
              <p className="text-gray-700 leading-relaxed text-center italic">
                "To foster a united Leo community where every member rises with strength, purpose, and passion—empowered to lead, grow, and create a lasting impact."
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-secondary to-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-2xl">🎯</span>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2">Mission 2025/2026</h4>
              </div>
              <p className="text-gray-700 leading-relaxed text-center italic">
                "To cultivate an environment where every Leo is empowered to grow both personally and collectively, fostering leadership rooted in strength, unity, and shared purpose, driving impactful change within our club and the communities we serve."
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="text-2xl font-bold text-primary mb-2">Unity & Strength</div>
              <div className="text-gray-600">Building stronger bonds among members</div>
            </div>
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="text-2xl font-bold text-primary mb-2">Personal Growth</div>
              <div className="text-gray-600">Empowering individual development</div>
            </div>
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="text-2xl font-bold text-primary mb-2">Lasting Impact</div>
              <div className="text-gray-600">Creating meaningful community change</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipLegacySection;